module.exports = __webpack_public_path__ + "img/21.5d2af8cd.jpg";